import './global-styles';
import { httpClient } from '@manager/api/http-client';
import { setHttpClient } from '@manager/api/services/auth-service';
import { setupMsw } from 'shared/msw';
import { logHiringMessage, logVersion } from 'shared/utils';
import { createApp } from 'vue';

import App from './App.vue';
import { installPlugins } from './plugins';
import { setDayjsLocale } from './plugins/dayjs';
import { i18nInit } from './plugins/i18n-plugin';
import { setupPostHog } from './plugins/posthog-plugin';
import { routerInit } from './plugins/router-plugin';
import { setupSentry } from './plugins/sentry-plugin';
import { vueUseHeadInit } from './plugins/use-head-plugin';
import { piniaInit } from './plugins/use-pinia-plugin';
import { vueMotion } from './plugins/vue-motion-plugin';
import { vueQueryInit } from './plugins/vue-query-plugin';
import { vuetifyInit } from './plugins/vuetify-plugin';
import router from './router';
import { migrateDataGridLocalStorageKeys } from './utils/local-storage-migration-utils';

migrateDataGridLocalStorageKeys();

if (window !== window.parent) {
  const message =
    'Embedding the Kinnovis manager via iFrame is not supported. Reach out to our support team in case you have any questions.';
  document.getElementsByTagName('body')[0].innerHTML =
    `<h2 class="text-2xl text-center mt-4">${message}</h2>`;
  throw new Error(message);
}

async function initApp() {
  setHttpClient(httpClient);

  const app = createApp(App);

  logVersion();
  logHiringMessage();
  setDayjsLocale('en');

  installPlugins(
    app,
    routerInit,
    i18nInit,
    piniaInit,
    vuetifyInit,
    vueQueryInit,
    vueUseHeadInit,
    vueMotion
  );

  setupSentry(app, router);
  setupPostHog(router);
  await setupMsw({
    app,
    handlers: () => import('@manager/msw/handlers'),
  });
  app.mount('#app');
}

initApp();
